import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { getRequestWithToken, postRequest } from "../../utils/ApiRequests";
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import { Box, Button, Chip, Container, Grid, Typography, TextField, MenuItem, FormControl, InputLabel, Select, Radio, RadioGroup, FormControlLabel, FormLabel, Checkbox } from '@mui/material';
import { GlobalContext } from '../../components/GlobalStateProvide/GlobalStateProvider';
import "./employer.scss";
import BackBtn from '../../components/backButton/BackBtn';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { AddEmployerCreditsValidationSchema } from '../../utils/Validations';
import FocusError from '../../components/FocusError/FocusError';

import { checkPermission } from "../../utils/userPermissions";
import Unauthorized from "../../components/unauthorized/Unauthorized";

const EmployerDetails = () => {
  const { employerId } = useParams();
  const [searchParams] = useSearchParams();
  const u = searchParams.get("u");
  const [employerData, setEmployerData] = useState([]);
  const [employerTransactionsData, setEmployerTransactionsData] = useState([]);
  const [employerPostedJobsData, setEmployerPostedJobsData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const { handleSnackBar } = useContext(GlobalContext);
  const location = useLocation();

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isError, setIsError] = useState(false);

  const [columnFilters2, setColumnFilters2] = useState([]);
  const [globalFilter2, setGlobalFilter2] = useState("");
  const [sorting2, setSorting2] = useState([]);
  const [isRefetching2, setIsRefetching2] = useState(false);
  const [isError2, setIsError2] = useState(false);

  const [rowCount, setRowCount] = useState(0);
  const [rowCount2, setRowCount2] = useState(0);
  const [loadingDataInTranxTable, setLoadingDataInTranxTable] = useState(null);
  const [loadingDataInJobsTable, setLoadingDataInJobsTable] = useState(null);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [pagination2, setPagination2] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [canCreate, setCanCreate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canRead, setCanRead] = useState(false);

  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(null);

  // Credit form state
  const [addonList, setAddonList] = useState([]);
  const [loadingAddons, setLoadingAddons] = useState(false);

  const creditFormInitialValues = {
    creditMode: 'custom',
    creditType: 1,
    operation: 'credit',
    reason: '',
    systemMessage: '',
    creditAmount: '',
    validityDays: '',
    addonId: '',
    hasPaymentTransaction: false,
    amount: '',
    paymentMode: '',
    bankTransactionId: '',
    paymentGatewayTransactionId: '',
    paymentGatewayServiceTransactionId: '',
    bankId: '',
    arn: ''
  };

  const columns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        const rowIndex = row.index;
        return <span>{rowIndex + 1 + pageIndex * pageSize}</span>;
      },
    },
    { accessorKey: "merchantTransactionId", size: 250, header: "Transaction ID" },
    { accessorKey: "merchantId", size: 170, header: "Merchant ID" },
    {
      accessorKey: "paymentDate", size: 220, header: "Transaction Date",
      enableColumnFilter: false,
      Cell: ({ cell }) => (cell.getValue() ?
        <span>
          {new Date(cell.getValue()).toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
          })}
        </span> : '--'
      ),
    },
    { accessorKey: "planType", header: "Transaction Type", enableColumnFilter: false, },
    { accessorKey: "paymentMode", size: 180, header: "Mode of Payment", enableColumnFilter: false, },
    { accessorKey: "amount", size: 150, header: "Amount", enableColumnFilter: false, },
    { accessorKey: "creditType", size: 120, header: "Type", enableColumnFilter: false, },
    { accessorKey: "creditCount", size: 150, header: "Credits", enableColumnFilter: false, },
    { accessorKey: "state", header: "Payment Status", enableColumnFilter: false, },
    { accessorKey: "comment", header: "Reason", enableColumnFilter: false, },
    { accessorKey: "systemMessage", header: "System Message", enableColumnFilter: false, },
    {
      accessorKey: "doewnloadInvoice",
      header: "Action",
      size: 200,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <div style={{ textTransform: "uppercase" }}>
          {row?.original?.invoiceLink && <Button style={{ textTransform: "capitalize" }} onClick={() => handleDownloadInvoice(row?.original?.invoiceLink)}>View/Download Invoice</Button>}
        </div>
      ),
    },
  ];

  const handleDownloadInvoice = (invoiceLink) => {
    if (invoiceLink) {
      window.open(invoiceLink, '_blank');
    } else {
      handleSnackBar(true, "Invoice link not available", "error");
    }
  };


  const jobDataColumns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        const rowIndex = row.index;
        return <span>{rowIndex + 1 + pageIndex * pageSize}</span>;
      },
    },
    {
      accessorKey: "jobId",
      header: "Job ID",
      Cell: ({ row }) => (
        <a
          href={`/posted-jobs/${row?.original?._id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:underline"
          style={{ cursor: canRead ? 'pointer' : 'not-allowed' }}
          onClick={(e) => !canRead && e.preventDefault()}
        >
          {row.original.jobId}
        </a>
      ),
    },
    { accessorKey: "jobRoleNameEn", id: 'jobRole', header: "Job Role" },
    {
      accessorKey: "jobLiveAt",
      enableColumnFilter: false,
      Cell: ({ cell }) => (cell.getValue() ?
        <span>
          {new Date(cell.getValue()).toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
          })}
        </span> : '--'
      ), header: "Date Posted"
    },
    {
      accessorKey: "city",
      header: "Location",
      enableColumnFilter: false,
      accessorFn: (row) => {
        let { city, state } = row.jobDescription?.jobLocation || {};
        return (
          [city, state].filter(Boolean).join(", ")
        )
        // row.jobDescription?.jobLocation.state ?? "---"},
      }
    },
    {
      accessorKey: "status",
      enableColumnFilter: false,
      accessorFn: (row) => {
        if (row?.deleted?.isDeleted) return "Deleted";
        if (row?.isArchived) return "Archived";
        if (row?.isDraft) return "Draft";
        if (row?.isActive) return "Active";
        if (row?.isAdminApprovalNeed) return "Admin Approval Needed";
        if (row?.isRejectedByAdmin) return "Rejected By Admin";
        return "Unknown";
      },
      header: "Status"
    },
  ];

  const getEmployerDetails = async () => {
    try {
      let response = await getRequestWithToken(`admin/userbyid?usertype=employer&userid=${employerId}`);
      setEmployerData(response.data.data);
      // console.log("response : " + JSON.stringify(response.data.data))
      setShowLoader(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setShowLoader(false);
    }
  };

  const getEmployerTransactionsDetails = async () => {
    setLoadingDataInTranxTable(true);
    try {

      const filterParams = {
        // global: globalFilter,
        ...Object.fromEntries(
          columnFilters.map((filter) => [filter.id, filter.value])
        ),
      };
      const filterQueryString = new URLSearchParams(filterParams).toString();

      let response = await getRequestWithToken(`admin/employer/transaction?page=${pagination.pageIndex + 1}&limit=${pagination.pageSize}&employerId=${employerId}&${filterQueryString}`);
      setEmployerTransactionsData(response.data.data);
      setRowCount(response?.data?.totalCount);
      // console.log("response : " + JSON.stringify(response.data.data))
      setLoadingDataInTranxTable(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setLoadingDataInTranxTable(false);
    }
  };

  const getEmployerPostedJobsDetails = async () => {
    setLoadingDataInJobsTable(true);
    try {

      const filterParams = {
        // global: globalFilter,
        ...Object.fromEntries(
          columnFilters2.map((filter) => [filter.id, filter.value])
        ),
      };
      const filterQueryString2 = new URLSearchParams(filterParams).toString();

      let response = await getRequestWithToken(`admin/employer/jobs?page=${pagination2.pageIndex + 1}&limit=${pagination2.pageSize}&employerId=${employerId}&${filterQueryString2}`);
      setEmployerPostedJobsData(response.data.data);
      setRowCount2(response?.data?.totalCount);
      // console.log("response : " + JSON.stringify(response.data.data))
      setLoadingDataInJobsTable(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setLoadingDataInJobsTable(false);
    }
  };

  useEffect(() => {

    getEmployerDetails();
  }, [employerId
  ]);


  useEffect(() => {
    getEmployerTransactionsDetails();
  }, [employerId,
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  useEffect(() => {
    getEmployerPostedJobsDetails();
  }, [employerId,
    columnFilters2,
    globalFilter2,
    pagination2.pageIndex,
    pagination2.pageSize,
    sorting2,
  ]);



  useEffect(() => {
    // console.log("data response: ", JSON.stringify(employerData));
  }, [employerData]);

  // Fetch addons function will be called from within Formik when needed

  // Fetch addon packs
  const fetchAddons = async (creditType) => {
    setLoadingAddons(true);
    try {
      const response = await getRequestWithToken(`admin/addon?type=${creditType}`);
      setAddonList(response?.data?.data || []);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || "Failed to fetch addon packs", "error");
      setAddonList([]);
    } finally {
      setLoadingAddons(false);
    }
  };

  // Handle addon selection
  const handleAddonChange = (e, setFieldValue, creditType) => {
    const selectedAddonId = e.target.value;
    const selectedAddon = addonList.find(addon => addon._id === selectedAddonId);

    if (selectedAddon) {
      setFieldValue('addonId', selectedAddonId);
      setFieldValue('creditAmount', creditType === 1 ? selectedAddon.hcCredit : selectedAddon.phcCredit || 0);
      setFieldValue('validityDays', selectedAddon.expiryDuration);
      setFieldValue('amount', selectedAddon.amount);
    }
  };

  // Handle credit form submission
  const handleCreditFormSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Payment transaction is mandatory for addon mode
      if (values.creditMode === 'addon' && !values.hasPaymentTransaction) {
        handleSnackBar(true, "Payment transaction details are required for addon packs", "error");
        setSubmitting(false);
        return;
      }

      const payload = {
        employerId: employerId,
        creditType: Number(values.creditType),
        operation: values.operation,
        reason: values.reason,
        systemMessage: values.systemMessage
      };
      console.log("payload", payload);
      // return;
      // Add fields based on credit mode
      if (values.creditMode === 'addon') {
        payload.addonId = values.addonId;
      } else {
        payload.creditAmount = Number(values.creditAmount);
        // Include validityDays only for credit operation
        if (values.operation === 'credit' && values.validityDays) {
          payload.validityDays = Number(values.validityDays);
        }
      }

      // Add payment transaction fields if provided
      if (values.hasPaymentTransaction) {
        payload.amount = Number(values.amount);
        payload.paymentMode = values.paymentMode;
        if (values.bankTransactionId) payload.bankTransactionId = values.bankTransactionId;
        if (values.paymentGatewayTransactionId) payload.paymentGatewayTransactionId = values.paymentGatewayTransactionId;
        if (values.paymentGatewayServiceTransactionId) payload.paymentGatewayServiceTransactionId = values.paymentGatewayServiceTransactionId;
        if (values.bankId) payload.bankId = values.bankId;
        if (values.arn) payload.arn = values.arn;
      }

      const response = await postRequest('admin/employer/add-credits', payload);

      handleSnackBar(true, response?.data?.msg || "Credits updated successfully", "success");

      // Reset form
      resetForm();
      setAddonList([]);

      // Refresh employer details
      getEmployerDetails();
      getEmployerTransactionsDetails();

    } catch (error) {
      handleSnackBar(true, error?.response?.data?.msg || error?.message || "Failed to update credits", "error");
    } finally {
      setSubmitting(false);
    };
  }

  const table = useMaterialReactTable({
    columns,
    data: employerTransactionsData,

    initialState: { showColumnFilters: false },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    enableGlobalFilter: false,
    // enableColumnFilters: false,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      style: {
        backgroundColor: "#ff671f", // Custom orange color
      },
    },
    muiCircularProgressProps: {
      color: "secondary",
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "No Data",
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading: loadingDataInTranxTable,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
    renderBottomToolbarCustomActions: ({ table }) => {
      const { pageIndex, pageSize } = table.getState().pagination;
      const totalPages = Math.ceil(rowCount / pageSize);
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" style={{ marginLeft: "10px" }}>
            Page {pageIndex + 1} of {totalPages}
          </Typography>
        </Box>
      );
    },
    renderTopToolbarCustomActions: ({ table }) => {
      const pinnedColumns = table.getState().columnPinning;
      return (
        <Box>
          <Chip
            label={`Left Pinned: ${pinnedColumns.left.length}`}
            color="primary"
            sx={{ mr: 1 }}
          />
          <Chip
            label={`Right Pinned: ${pinnedColumns.right.length}`}
            color="secondary"
          />
        </Box>
      );
    },
  });


  const jobTable = useMaterialReactTable({
    columns: jobDataColumns,
    data: employerPostedJobsData,

    initialState: { showColumnFilters: false },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    enableGlobalFilter: false,
    enableColumnFilters: true,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      style: {
        backgroundColor: "#ff671f", // Custom orange color
      },
    },
    muiCircularProgressProps: {
      color: "secondary",
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "No Data",
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters2,
    onGlobalFilterChange: setGlobalFilter2,
    onPaginationChange: setPagination2,
    onSortingChange: setSorting2,
    rowCount: rowCount2,
    state: {
      columnFilters2,
      globalFilter2,
      isLoading: loadingDataInJobsTable,
      pagination: pagination2,
      showAlertBanner: isError2,
      showProgressBars: isRefetching2,
      sorting2,
    },
    renderBottomToolbarCustomActions: ({ table }) => {
      const { pageIndex, pageSize } = table.getState().pagination;
      const totalPages = Math.ceil(rowCount2 / pageSize);
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" style={{ marginLeft: "10px" }}>
            Page {pageIndex + 1} of {totalPages}
          </Typography>
        </Box>
      );
    },
    // renderTopToolbarCustomActions: ({ table }) => {
    //   const pinnedColumns = table.getState().columnPinning;
    //   return (
    //     <Box>
    //       <Chip
    //         label={`Left Pinned: ${pinnedColumns.left.length}`}
    //         color="primary"
    //         sx={{ mr: 1 }}
    //       />
    //       <Chip
    //         label={`Right Pinned: ${pinnedColumns.right.length}`}
    //         color="secondary"
    //       />
    //     </Box>
    //   );
    // },
  });

  const checkPermissionFunc = () => {
    const resourceToUpdate = u === "employer" ? "Employer" : "Recruiter";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate);
    setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    const checkAccesInArray = localStorage.getItem("resourceNames");
    setisAccess(checkAccesInArray);
    isIncludes();
  };

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes(u === "employer" ? "Employer" : "Recruiter"));
  };

  useEffect(() => {
    // getAllJobs();
    checkPermissionFunc();
    againCheckPermissions();
  }, [isIncludesValue]);

  return isIncludesValue ? (
    (showLoader) ? <ReusableLoader /> :
      <Box className="create-candidates-section">

        <Container>

          <Box className="create-candidates">
            <Box className="headingPlusBackBtn">
              {/* <BackBtn /> */}
              <h1 className='formHeadings' style={{ textTransform: 'capitalize' }} id="topEle" >{u} Details</h1>
            </Box>
            <Box className="create-candidates-form-wrapper">

              <Box>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography variant="h7" component="h4">Personal Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="backgroundStyle">
                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>
                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'> First Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.firstName ? employerData?.firstName : '--'}</Typography>
                            </Box>
                          </Grid>

                          {/* <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'> Middle Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.middleName ? employerData?.middleName : '--'}</Typography>
                            </Box>
                          </Grid> */}

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >Last Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.lastName ? employerData?.lastName : '--'}</Typography>
                            </Box>
                          </Grid>

                        </Grid>
                      </Box>

                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>
                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'>Mobile Number</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.phone ? employerData?.phone : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'>Email Address</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.email ? employerData?.email : '--'}</Typography>
                            </Box>
                          </Grid>

                        </Grid>
                      </Box>

                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'  >Company Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.companyName ? employerData?.companyName : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' > Address</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.fullAddress ? employerData?.companyAddress?.fullAddress : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' > Pincode</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.pincode ? employerData?.companyAddress?.pincode : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >City</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.city ? employerData?.companyAddress?.city : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >State</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.state ? employerData?.companyAddress?.state : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >Recruitment Agency</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.recruitmentAgency ? "Yes" : 'No'}</Typography>
                            </Box>
                          </Grid>
                        </Grid>

                        {employerData?.businessLogo && <Grid container spacing={2} className='cstmFormGridEmployer' style={{ marginTop: '5px' }}>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >BusinessLogo</Typography>
                              {/* <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.state}</Typography> */}
                              <img src={employerData?.businessLogo} width={250} style={{ borderRadius: "10px" }} alt="" />
                            </Box>
                          </Grid>

                        </Grid>}
                      </Box>
                    </Box>

                    <Box className="backgroundStyle">
                      <Grid container spacing={2} className='cstmFormGridEmployer'>
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <Typography variant="h7" component='h5'> PHC</Typography>
                            <Typography variant="subtitle2" style={{ paddingLeft: "5px", backgroundColor: "#e1f5fe", color: "#0277bd", fontWeight: "600" }} >{employerData?.plusHiringCredits?.availablePHC ? employerData?.plusHiringCredits?.availablePHC : '--'}</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <Typography variant="h7" component='h5'> HC</Typography>
                            <Typography variant="subtitle2" style={{ paddingLeft: "5px", backgroundColor: "#f3e5f5", color: "#6a1b9a", fontWeight: "600" }} >{employerData?.hiringCredits?.remainingHiringCredit ? employerData?.hiringCredits?.remainingHiringCredit : '--'}</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography variant="h7" component="h4">Credits settings</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="backgroundStyle">
                      <Box className='marginBottom10'>
                        <Formik
                          initialValues={creditFormInitialValues}
                          validationSchema={AddEmployerCreditsValidationSchema}
                          onSubmit={handleCreditFormSubmit}
                          enableReinitialize
                        >
                          {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting, resetForm }) => (
                            <Form>
                              <FocusError handleSnackBar={handleSnackBar} />
                              <Grid container spacing={2} className='cstmFormGridEmployer'>
                                {/* Credit Mode Selection */}
                                <Grid item xs={12}>
                                  <FormControl component="fieldset">
                                    <FormLabel component="legend">Credit Mode</FormLabel>
                                    <RadioGroup
                                      row
                                      name="creditMode"
                                      value={values.creditMode}
                                      onChange={(e) => {
                                        const newMode = e.target.value;
                                        setFieldValue('creditMode', newMode);
                                        if (newMode === 'custom') {
                                          setFieldValue('addonId', '');
                                          setFieldValue('hasPaymentTransaction', false);
                                        } else {
                                          // Addon mode: force credit operation and enable payment transaction
                                          setFieldValue('creditAmount', '');
                                          setFieldValue('validityDays', '');
                                          setFieldValue('operation', 'credit');
                                          setFieldValue('hasPaymentTransaction', true);
                                          // Fetch addons
                                          fetchAddons(values.creditType);
                                        }
                                      }}
                                    >
                                      <FormControlLabel value="custom" control={<Radio />} label="Custom Credits" />
                                      <FormControlLabel value="addon" control={<Radio />} label="Use Addon Pack" />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>

                                {/* Credit Type - Common for both modes */}
                                <Grid item xs={12} sm={6} md={4}>
                                  <FormControl fullWidth required error={touched.creditType && Boolean(errors.creditType)}>
                                    <InputLabel>Credit Type</InputLabel>
                                    <Select
                                      name="creditType"
                                      value={values.creditType}
                                      onChange={(e) => {
                                        handleChange(e);
                                        // If addon mode, refetch addons with new credit type
                                        if (values.creditMode === 'addon') {
                                          setFieldValue('addonId', '');
                                          fetchAddons(e.target.value);
                                        }
                                      }}
                                      onBlur={handleBlur}
                                      label="Credit Type"
                                    >
                                      <MenuItem value={1}>HC (Hiring Credits)</MenuItem>
                                      <MenuItem value={2}>PHC (Plus Hiring Credits)</MenuItem>
                                    </Select>
                                    {touched.creditType && errors.creditType && (
                                      <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                        {errors.creditType}
                                      </Typography>
                                    )}
                                  </FormControl>
                                </Grid>

                                {/* Custom Credit Fields */}
                                {values.creditMode === 'custom' && (
                                  <>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Amount"
                                        name="creditAmount"
                                        type="number"
                                        value={values.creditAmount}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.creditAmount && Boolean(errors.creditAmount)}
                                        helperText={touched.creditAmount && errors.creditAmount}
                                        InputProps={{ inputProps: { min: 0 } }}
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Validity Days"
                                        name="validityDays"
                                        type="number"
                                        value={values.validityDays}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.validityDays && Boolean(errors.validityDays)}
                                        helperText={
                                          (touched.validityDays && errors.validityDays) ||
                                          (values.operation === 'debit' ? 'Not required for debit operation' : '')
                                        }
                                        InputProps={{ inputProps: { min: 0 } }}
                                      />
                                    </Grid>
                                  </>
                                )}

                                {/* Addon Pack Selection */}
                                {values.creditMode === 'addon' && (
                                  <Grid item xs={12} sm={6} md={4}>
                                    <FormControl fullWidth required disabled={loadingAddons} error={touched.addonId && Boolean(errors.addonId)}>
                                      <InputLabel>Select Addon Pack</InputLabel>
                                      <Select
                                        name="addonId"
                                        value={values.addonId}
                                        onChange={(e) => handleAddonChange(e, setFieldValue, values.creditType)}
                                        onBlur={handleBlur}
                                        label="Select Addon Pack"
                                      >
                                        {loadingAddons ? (
                                          <MenuItem disabled>Loading...</MenuItem>
                                        ) : addonList.length === 0 ? (
                                          <MenuItem disabled>No addon packs available</MenuItem>
                                        ) : (
                                          addonList.map((addon) => (
                                            <MenuItem key={addon._id} value={addon._id}>
                                              {addon.addonPackName} - ₹{addon.amount} ({values.creditType === 1 ? addon.hcCredit : addon.phcCredit || 0} credits, {addon.expiryDuration} days)
                                            </MenuItem>
                                          ))
                                        )}
                                      </Select>
                                      {touched.addonId && errors.addonId && (
                                        <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                          {errors.addonId}
                                        </Typography>
                                      )}
                                    </FormControl>
                                  </Grid>
                                )}

                                {/* Operation */}
                                <Grid item xs={12} sm={6} md={4}>
                                  <FormControl fullWidth required disabled={values.creditMode === 'addon'} error={touched.operation && Boolean(errors.operation)}>
                                    <InputLabel>Operation</InputLabel>
                                    <Select
                                      name="operation"
                                      value={values.operation}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      label="Operation"
                                    >
                                      <MenuItem value="credit">Credit</MenuItem>
                                      <MenuItem value="debit">Debit</MenuItem>
                                    </Select>
                                    {touched.operation && errors.operation && (
                                      <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                        {errors.operation}
                                      </Typography>
                                    )}
                                  </FormControl>
                                  {values.creditMode === 'addon' && (
                                    <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5 }}>
                                      Operation is always "Credit" for addon packs
                                    </Typography>
                                  )}
                                </Grid>

                                <Grid item xs={12} sm={6} md={4}>
                                  <FormControl fullWidth required error={touched.reason && Boolean(errors.reason)}>
                                    <InputLabel>Reason</InputLabel>
                                    <Select
                                      name="reason"
                                      value={values.reason}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      label="Reason"
                                    >
                                      <MenuItem value="Credited as welcome bonus.">Credited as welcome bonus.</MenuItem>
                                      <MenuItem value="Promotional credits added.">Promotional credits added.</MenuItem>
                                      <MenuItem value="Added after successful payment.">Added after successful payment.</MenuItem>
                                      <MenuItem value="Credited by JobsYahan support.">Credited by JobsYahan support.</MenuItem>
                                      <MenuItem value="Adjusted as per account review.">Adjusted as per account review.</MenuItem>
                                      <MenuItem value="Debited by JobsYahan support.">Debited by JobsYahan support.</MenuItem>
                                    </Select>
                                    {touched.reason && errors.reason && (
                                      <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                        {errors.reason}
                                      </Typography>
                                    )}
                                  </FormControl>

                                </Grid>

                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    label="System Message"
                                    name="systemMessage"
                                    multiline
                                    rows={3}
                                    value={values.systemMessage}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.systemMessage && Boolean(errors.systemMessage)}
                                    helperText={touched.systemMessage && errors.systemMessage}
                                    placeholder="Enter message for credit/debit operation"
                                  />

                                </Grid>

                                {/* Payment Transaction Toggle */}
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        name="hasPaymentTransaction"
                                        checked={values.hasPaymentTransaction}
                                        onChange={(e) => {
                                          setFieldValue('hasPaymentTransaction', e.target.checked);
                                        }}
                                        disabled={values.creditMode === 'addon'}
                                      />
                                    }
                                    label="Has Payment Transaction Details"
                                  />
                                  {values.creditMode === 'addon' && (
                                    <Typography variant="caption" color="textSecondary" sx={{ ml: 4, display: 'block' }}>
                                      Payment transaction details are mandatory for addon packs
                                    </Typography>
                                  )}
                                </Grid>

                                {/* Payment Transaction Fields */}
                                {values.hasPaymentTransaction && (
                                  <>
                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Payment Amount"
                                        name="amount"
                                        type="number"
                                        value={values.amount}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.amount && Boolean(errors.amount)}
                                        helperText={touched.amount && errors.amount}
                                        InputProps={{ inputProps: { min: 0 } }}
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                      <FormControl fullWidth error={touched.paymentMode && Boolean(errors.paymentMode)}>
                                        <InputLabel>Payment Mode</InputLabel>
                                        <Select
                                          name="paymentMode"
                                          value={values.paymentMode}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          label="Payment Mode"
                                        >
                                          <MenuItem value="">Select Payment Mode</MenuItem>
                                          <MenuItem value="UPI">UPI</MenuItem>
                                          <MenuItem value="NEFT">NEFT</MenuItem>
                                          <MenuItem value="RTGS">RTGS</MenuItem>
                                          <MenuItem value="IMPS">IMPS</MenuItem>
                                          <MenuItem value="Card">Card</MenuItem>
                                          <MenuItem value="Net Banking">Net Banking</MenuItem>
                                          <MenuItem value="Cash">Cash</MenuItem>
                                          <MenuItem value="Cheque">Cheque</MenuItem>
                                        </Select>
                                        {touched.paymentMode && errors.paymentMode && (
                                          <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                                            {errors.paymentMode}
                                          </Typography>
                                        )}
                                      </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Bank Transaction ID"
                                        name="bankTransactionId"
                                        value={values.bankTransactionId}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Payment Gateway Transaction ID"
                                        name="paymentGatewayTransactionId"
                                        value={values.paymentGatewayTransactionId}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Payment Gateway Service Transaction ID"
                                        name="paymentGatewayServiceTransactionId"
                                        value={values.paymentGatewayServiceTransactionId}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="Bank ID"
                                        name="bankId"
                                        value={values.bankId}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                      <TextField
                                        fullWidth
                                        label="ARN"
                                        name="arn"
                                        value={values.arn}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                    </Grid>
                                  </>
                                )}

                                {/* Submit and Reset Buttons */}
                                <Grid item xs={12}>
                                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      color="primary"
                                      disabled={isSubmitting}
                                    >
                                      {isSubmitting ? `${values.operation === "credit" ? "crediting..." : "debiting..."}` : `${values.operation}`}
                                    </Button>
                                    <Button
                                      type="button"
                                      variant="outlined"
                                      color="secondary"
                                      onClick={() => {
                                        resetForm();
                                        setAddonList([]);
                                      }}
                                    >
                                      Reset
                                    </Button>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Form>
                          )}
                        </Formik>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h7" component="h4">Transaction Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>

                    <MaterialReactTable
                      table={table}
                    />
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h7" component="h4">Posted Jobs Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MaterialReactTable
                      table={jobTable}
                    />
                  </AccordionDetails>
                </Accordion>
              </Box>

            </Box>
          </Box>
        </Container>

      </Box >) : <Unauthorized />;
};

export default EmployerDetails;
